<template>
  <lateral-modal
    id="category-and-subcategories-modal"
    :title="$t('company_details_categories_and_subcategories')"
    @close="closeModal"
    :containerClass="'ModalBox-container position-relative px-4 mt-5'"
  >
    <template slot="extraAction">
      <span
        class="link action-container"
        @click="handleShowCreateCategory"
      >{{$t('company_details_new_category_button')}}</span>
    </template>
    <template slot="content">

      <div
        class="categories-table"
        v-if="!loading && categoriesReady"
      >
        <div class="categories-table--header">
          <div
            class="name"
            v-t="{ path: 'company_details_category_field' }"
          ></div>
          <div
            class="account-number"
            v-t="{ path: 'company_details_account_number_field' }"
          ></div>
          <div
            class="tax-code"
            v-t="{ path: 'company_details_tax_field' }"
          ></div>
          <div></div>

        </div>
        <div
          class="categories-table--category"
          v-for="category in categories"
          :key="category.id"
        >
          <category-row
            :category="category"
            :isShown="isShown(category.id)"
            @editCategory="editCategory(category)"
            @removeCategory="handleRemoveCategory(category.id)"
            @close="handleCategoryClose()"
            @toggle="toggleHidden(category.id)"
          ></category-row>
          <template v-if="isShown(category.id)">
            <subcategory-row
              v-for="subcategory in category.customCategories"
              :subcategory="subcategory"
              :key="subcategory.id"
              :editing="isEditingSubcategory(subcategory.id)"
              :category="category"
              @edit="editSubcategory(subcategory.id)"
              @removeSubcategory="handleRemoveSubcategory"
              @close="handleSubcategoryClose"
            ></subcategory-row>
          </template>
          <transition
            name="fade"
            mode="out-in"
          >
            <template v-if="!isCreatingSubcategory(category.id)">
              <div class="link add-subcategory">
                <a @click="addSubcategory(category.id)">
                  +
                  <span v-t="{ path: 'company_details_new_subcategory_button' }"></span>
                </a>
              </div>
            </template>
            <template v-else>
              <subcategory-row
                class="create-category-form"
                :subcategory="{}"
                :editing="true"
                :category="category"
                @removeSubcategory="handleRemoveSubcategory"
                @close="handleSubcategoryClose"
              ></subcategory-row>
            </template>
          </transition>

        </div>
      </div>

      <div
        class="d-flex w-100 h-100 justify-content-center align-items-center"
        v-else
      >
        <spinner />
      </div>

    </template>
    <template slot="modals">
      <create-category-modal
        @close="showCreateCategoryModalFlag = false"
        :category="categoryToEdit"
        v-if="showCreateCategoryModalFlag"
      />
      <confirm-modal
        :id="'confirm-delete-category-modal'"
        :open.sync="showConfirmDeleteCategoryModalFlag"
        v-if="showConfirmDeleteCategoryModalFlag"
        :title="'company_details_delete_category_title'"
        :message="'company_details_dete_category_info'"
        :acceptText="'ACTION_REMOVE'"
        :dismissText="'ACTION_CANCEL'"
        @accept="deleteCategory"
      />
      <confirm-modal
        v-if="showConfirmDeleteSubcategoryFlag"
        :open.sync="showConfirmDeleteSubcategoryFlag"
        @accept="deleteSubcategory"
        @dismiss="dismissDeleteSubcategory"
        :title="'company_details_remove_subcategory_action'"
        :acceptText="'company_details_remove_subcategory_action'"
        :message="$t('company_details_confirm_modal_delete_subcategory', { name: subcategoryToRemove.name })"
      ></confirm-modal>

    </template>

  </lateral-modal>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
import LateralModal from '@/components/Commons/Modals/LateralModal.vue'
import CategoryRow from '@/modules/company/_components/transaction_fields/CategoryRow'
import SubcategoryRow from '@/modules/company/_components/transaction_fields/SubcategoryRow'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
const CreateCategoryModal = () => import('./CreateCategoryModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
export default {

  components: { Spinner, LateralModal, CategoryRow, SubcategoryRow, CreateCategoryModal, ConfirmModal },
  mixins: [_modalHandlerMixin],
  data () {
    return {
      categoriesHidden: [],
      categoryToEdit: false,
      addSubcategoryToCategoryId: false,
      categoriesMerged: [],
      categoriesReady: false,
      showCreateCategoryModalFlag: false,
      showConfirmDeleteCategoryModalFlag: false,
      showConfirmDeleteSubcategoryFlag: false,
      editSubcategoryId: false,
      subcategoryToRemove: false

    }
  },
  computed: {
    loading () {
      return this.$store.getters['CategoriesStore/isCallingCategories']
    },
    categories () {
      return this.$store.getters['CategoriesStore/categories'] || []
    },
    customCategories () {
      return this.$store.getters['CategoriesStore/customCategories'] || []
    }
    // defaultCategoriesOffice () {
    //   return this.$store.getters['CategoriesStore/defaultCategoriesOffice'] || []
    // }
  },
  methods: {
    isEditingSubcategory (id) {
      return this.editSubcategoryId === id
    },
    isEditingCategory (id) {
      return this.categoryToEdit === id
    },
    isCreatingSubcategory (id) {
      return this.addSubcategoryToCategoryId === id
    },
    addSubcategory (id) {
      if (!this.isShown(id)) this.toggleHidden(id)
      this.editSubcategoryId = false
      this.addSubcategoryToCategoryId = id
    },
    editSubcategory (id) {
      this.addSubcategoryToCategoryId = false
      this.editSubcategoryId = id
    },
    editCategory (category) {
      this.categoryToEdit = category
      this.showCreateCategoryModalFlag = true
    },
    handleShowCreateCategory () {
      this.categoryToEdit = false
      this.showCreateCategoryModalFlag = true
    },
    closeModal () {
      this.$emit('close')
    },
    handleCategoryClose () {
      this.categoryToEdit = false
      this.$forceUpdate()
    },
    handleSubcategoryClose () {
      this.editSubcategoryId = false
      this.addSubcategoryToCategoryId = false
    },
    toggleHidden (id) {
      if (this.isHidden(id)) {
        this.categoriesHidden.splice(this.categoriesHidden.indexOf(id), 1)
      } else {
        this.categoriesHidden.push(id)
      }
    },
    isShown (id) {
      return !this.isHidden(id)
    },
    isHidden (id) {
      return this.categoriesHidden.indexOf(id) > -1
    },
    mergeDefaultCategoriesOffice () {
      this.categories.forEach(category => {
        let defaultCategoryOffice = this.defaultCategoriesOffice.find(item => item.id === category.id)
        category.defaultCategoryOffice = defaultCategoryOffice || {}
      })
    },
    mergeCustomCategories () {
      this.categories.forEach(category => {
        let customCategories = this.customCategories.filter(item => item.defaultCategoryOffice?.id === category.id)
        category.customCategories = customCategories || {}
      })
    },
    handleRemoveCategory (event) {
      this.categoryToRemoveId = event
      this.showConfirmDeleteCategoryModalFlag = true
    },
    handleRemoveSubcategory (event) {
      this.subcategoryToRemove = event
      this.showConfirmDeleteSubcategoryFlag = true
    },
    dismissDeleteSubcategory () {
      this.subcategoryToRemove = false
      this.showConfirmDeleteSubcategoryFlag = false
    },
    async deleteSubcategory () {
      await this.$store.dispatch('CategoriesStore/deleteCustomSubcategory', this.subcategoryToRemove)
      this.dismissDeleteSubcategory()
      this.$forceUpdate()
    },
    async deleteCategory () {
      await this.$store.dispatch('CategoriesStore/removeCategory', this.categoryToRemoveId)
      this.$forceUpdate()
    }
  },
  created () {
    let promises = [this.$store.dispatch('CategoriesStore/fetchCustomCategories', false), this.$store.dispatch('CategoriesStore/fetchDefaultCategoriesOffice')]

    Promise.allSettled(promises).then(() => {
      // this.mergeDefaultCategoriesOffice()
      this.mergeCustomCategories()
      this.categoriesReady = true
    })
  }
}
</script>
<style lang="scss">
#category-and-subcategories-modal {
  width: 603px;

  // .Tit--modal {
  //   margin-left: 60px !important;
  // }

  .link {
    color: var(--text-link);
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
  }
  .action-container {
    position: absolute;
    right: 15px;
  }

  .categories-table--category {
    margin-top: 16px;
    margin-bottom: 12px;
    border-bottom: 1px solid var(--text-divider);

    &:last-of-type {
      border: none;
      padding-bottom: 10px;
    }
  }
  .ModalBox--medium {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    max-width: 428px;
  }
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  .Fuell-Modal--window {
    margin: 0px;
    padding: 14px 12px 24px;
  }
}

.categories-table {
  font-size: 15px;
  margin-top: 4px;
  &--header {
    display: grid;
    grid-column-gap: 8px;

    height: 44px;
    align-items: center;

    @media screen and (max-width: 576px) {
      grid-template-columns: minmax(120px, 185px) 75px 75px 80px;
      margin: 10px 0px;
      height: 100%;
    }
  }

  &--header {
    color: var(--text-body);
    background-color: var(--background);
    font-weight: 600;
    grid-template-columns: 333px 1fr 1fr 10px;

    position: sticky;
    top: -19px;
    z-index: 1;
    height: 24px;
  }

  &--row {
    font-size: 15px;
    font-weight: 500;
    color: var(--text-heading);
  }

  &--subcategory-row {
    font-size: 15px;
    font-weight: 300;
    color: var(--text-heading);
    background-color: white;
  }
}

.add-subcategory {
  font-size: 15px;
  margin: 10px 0px;
  cursor: pointer;
  color: var(--gray);
  font-weight: 300;
}

.create-category-form {
  margin-bottom: 5px;
}
</style>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
